import { Link } from "react-router-dom";
import FlowerButton from "@/components/FlowerButton";
import { useCart } from "@/context/CartContext";
import { findCharacter, fmtPrice } from "@/data/mellow";
import { StockBadge, useStockInfo } from "@/components/StockBadge";

export default function ProductCard({ product }) {
  const { add } = useCart();
  const char = findCharacter(product.character);
  const { soldOut } = useStockInfo(product.lookup_key);

  return (
    <div
      className="group relative flex flex-col rounded-3xl bg-[#FAF9F6] border-2 border-dashed border-[#D1D5CB] p-5 hover:-translate-y-1 transition-transform duration-300 shadow-[0_8px_30px_rgb(0,0,0,0.04)]"
      data-testid={`product-card-${product.lookup_key}`}
    >
      <Link to={`/produit/${product.lookup_key}`} className="relative block overflow-hidden rounded-2xl aspect-[7/10] mb-4" style={{ background: char?.bg || "#EAECE1" }} data-testid={`product-link-${product.lookup_key}`}>
        <img
          src={product.img}
          alt={product.name}
          loading="lazy"
          className={`w-full h-full ${product.fit === "contain" ? "object-contain p-6" : "object-cover"} group-hover:scale-105 transition-transform duration-500`}
        />
        {char && (
          <span className="absolute top-3 left-3 text-xs font-semibold px-3 py-1 rounded-full bg-[#FAF9F6]/85 backdrop-blur text-[#78353A]">
            {char.name}
          </span>
        )}
        {product.isNew && !product.comingSoon && (
          <span className="absolute top-3 right-3 font-cursive text-lg px-3 py-1 rounded-full bg-[#FFF2B2] text-[#78353A] -rotate-3 shadow animate-float-slow" data-testid={`new-badge-${product.lookup_key}`}>
            Nouveau ✿
          </span>
        )}
        {product.comingSoon && (
          <span className="absolute top-3 right-3 font-cursive text-lg px-3 py-1 rounded-full bg-[#FADADD] text-[#78353A] rotate-3 shadow" data-testid={`coming-soon-${product.lookup_key}`}>
            Bientôt ✿
          </span>
        )}
      </Link>
      <Link to={`/produit/${product.lookup_key}`} className="hover:underline decoration-dotted underline-offset-4"><h3 className="font-cursive text-3xl text-[#78353A] leading-none">{product.name}</h3></Link>
      <p className="mt-2 text-sm text-[#4A3B32]/85 leading-relaxed line-clamp-2">{product.desc}</p>
      <Link to={`/produit/${product.lookup_key}`} className="mt-1 text-xs text-[#78353A] underline decoration-dotted underline-offset-4" data-testid={`product-more-${product.lookup_key}`}>Voir la fiche produit →</Link>
      <StockBadge lookup_key={product.lookup_key} className="mt-2 self-start" />
      <div className="mt-4 flex items-end justify-between gap-3">
        <span className="font-cursive text-4xl text-[#4A3B32] leading-none">
          {fmtPrice(product.price)}
          {product.compareAt && <span className="ml-2 align-middle text-xl text-[#4A3B32]/50 line-through" data-testid={`compare-at-${product.lookup_key}`}>{fmtPrice(product.compareAt)}</span>}
        </span>
        {product.comingSoon || soldOut ? (
          <span className="text-sm font-cursive text-xl text-[#78353A]/70 text-right" data-testid={`unavailable-${product.lookup_key}`}>{soldOut ? "Épuisé" : "Bientôt disponible"}</span>
        ) : (
          <FlowerButton
            variant="pink"
            onClick={() => add(product.lookup_key)}
            data-testid={`add-to-cart-${product.lookup_key}`}
            className="!text-base !py-3 !px-4"
          >
            Au panier
          </FlowerButton>
        )}
      </div>
      {char && (
        <Link
          to={`/personnages/${char.slug}`}
          className="mt-3 text-xs text-[#4A3B32]/60 hover:text-[#78353A] underline underline-offset-4 decoration-dashed"
        >
          Découvrir {char.name} →
        </Link>
      )}
    </div>
  );
}
